import React from "react";


const ReferralsPage = () => {

  return (

    <div>

      <h2>
        Referrals
      </h2>

      <p>
        Affiliate referral data will be displayed here.
      </p>

    </div>

  );

};


export default ReferralsPage;